module.exports = __webpack_public_path__ + "img/b386d6d.svg";